import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, Button, Chip, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, TextField, Box } from "@mui/material";

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import UndoIcon from "@mui/icons-material/Undo";

import moment from 'moment';

import { DownloadFile } from "../../helpers/DownloadFile";
import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { usePages } from "../../hooks/usePages";

import { RootState } from "../../store";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";

import { Layout } from "../../components/Layout";

import { DialogDocumento } from "../../dialogs/DialogDocumento";
import { DialogExpediente } from "../../dialogs/DialogExpediente";
import { DialogExhortoRecibido } from "../../dialogs/DialogExhortoRecibido";

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerEstatus } from '../../connections/catalogos/EstatusConnection';
import { ObtenerClaseExhorto } from "../../connections/catalogos/ClaseExhortoConnection";
import { ObtenerObjetoExhorto } from "../../connections/catalogos/ObjetoExhortoConnection";
import { ObtenerAutoridadesMaterias } from "../../connections/catalogos/AutoridadConnection";
import { ConsultarExhortosLibrados, DescargarExhortosLibrados } from "../../connections/tribunal/ExhortoLibradoConnection";
import { BuscarUsuariosExhortoLibradoAsignacion, BuscarUsuariosExhortoLibradoElaboro } from "../../connections/admin/UsuarioConnection";

import { EstatusProps } from "../../interfaces/catalogos/EstatusInterface";
import { MateriaProps } from "../../interfaces/catalogos/MateriaInterface";
import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";
import { UsuarioExhortoLibradoProps } from "../../interfaces/admin/UsuarioInterface";
import { ClaseExhortoProps } from "../../interfaces/catalogos/ClaseExhortoInterface";
import { ObjetoExhortoProps } from "../../interfaces/catalogos/ObjetoExhortoInterface";
import { ConsultaExhortosLibradosProps } from "../../interfaces/tribunal/ExhortoLibradoInterface";
import { defaultExpediente, ExpedienteProps } from "../../interfaces/recepcion/ExpedienteInterface";
import { defaultExhortoRecibido, ExhortoRecibidoProps } from "../../interfaces/recepcion/ExhortoRecibidoInterface";

export const ExhortosLibradosPage = () => {

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescargar, setLoadingDescargar] = useState( false );
    const [openDocumento, setOpenDocumento] = useState( false );

    const [documento, setDocumento] = useState( '' );

    const [expedienteSeleccionado, setExpedienteSeleccionado] = useState<ExpedienteProps>( defaultExpediente );
    const [exhortoRecibidoSeleccionado, setExhortoRecibidoSeleccionado] = useState<ExhortoRecibidoProps>( defaultExhortoRecibido );

    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [openDialogExhortoRecibido, setOpenDialogExhortoRecibido] = useState( false );

    const [recordCount, setRecordCount] = useState( 0 );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [numeroReferencia, setNumeroReferencia] = useState( '' );
    const [fecha, setFecha] = useState( '' );

    const [objetoExhorto, setObjetoExhorto] = useState( 0 );
    const [objetoExhortoArray, setObjetoExhortoArray] = useState<ObjetoExhortoProps[]>( [] );

    const [claseExhorto, setClaseExhorto] = useState( 0 );
    const [claseExhortoArray, setClaseExhortoArray] = useState<ClaseExhortoProps[]>( [] );

    const [estatus, setEstatus] = useState( 0 );
    const [estatusArray, setEstatusArray] = useState<EstatusProps[]>( [] );

    const [usuarioAsignado, setUsuarioAsignado] = useState( 0 );
    const [usuarioAsignadoArray, setUsuarioAsignadoArray] = useState<UsuarioExhortoLibradoProps[]>( [] );

    const [usuarioElaboro, setUsuarioElaboro] = useState( 0 );
    const [usuarioElaboroArray, setUsuarioElaboroArray] = useState<UsuarioExhortoLibradoProps[]>( [] );

    const [rows, setRows] = useState<ConsultaExhortosLibradosProps[]>( [] );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setFiltroAplicado( false );

        setMateria( 0 );
        setAutoridad( 0 );
        setNumeroReferencia( '' );
        setFecha( '' );
        setObjetoExhorto( 0 );
        setClaseExhorto( 0 );
        setEstatus( 0 );
        setUsuarioAsignado( 0 );

        setRows( [ ] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );

        resetPage();
    }

    const handleDescargar = async () => {

        setLoadingDescargar( true );

        await DescargarExhortosLibrados({
            idMateria: materia,
            idAutoridad: autoridad,
            referencia: numeroReferencia,
            fecha: fecha ? moment(fecha).format('YYYY-MM-DD') : '',
            idEstatus: estatus,
            idObjetoExhorto: objetoExhorto,
            idClaseExhorto: claseExhorto,
            idUsuarioElaboro: usuarioElaboro,
            idUsuarioAsignacion: usuarioAsignado
        }).then( resp => {

            if ( resp ) {

                setTimeout(() => {

                    DownloadFile( `Exhortos-Librados-${ Date.now() }.xlsx`, resp );

                    setLoadingDescargar( false );

                }, 700);

            }

        });

    }

    const handleVerDetalle = ( { expediente, exhortoRecibido }: ConsultaExhortosLibradosProps ) => {

        if ( exhortoRecibido.idExhortoRecibido !== 0 ) {
            setExhortoRecibidoSeleccionado( exhortoRecibido );
            setOpenDialogExhortoRecibido( true );
        }
        else if ( expediente.idExpediente !== 0 ) {
            setExpedienteSeleccionado( expediente );
            setOpenDialogExpediente( true );
        }

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerObjetoExhorto().then( resp => {
                setObjetoExhortoArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerClaseExhorto().then( resp => {
                setClaseExhortoArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstatus().then( resp => {
                setEstatusArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosExhortoLibradoAsignacion().then( resp => {
                setUsuarioAsignadoArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosExhortoLibradoElaboro().then( resp => {
                setUsuarioElaboroArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [ ] );

            await ConsultarExhortosLibrados({
                page,
                rowsPerPage,
                idAutoridad: 0,
                idMateria: 0,
                referencia: '',
                fecha: '',
                idObjetoExhorto: 0,
                idClaseExhorto: 0,
                idEstatus: 0,
                idUsuarioElaboro: 0,
                idUsuarioAsignacion: 0
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp?.recordsCount ?? 0 );
                    setRows( resp?.records ?? [] );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [ ] );

            const fechaStr = fecha ? moment(fecha).format('YYYY-MM-DD') : '';

            await ConsultarExhortosLibrados({
                page,
                rowsPerPage,
                idAutoridad: autoridad,
                idMateria: materia,
                referencia: numeroReferencia,
                fecha: fechaStr,
                idObjetoExhorto: objetoExhorto,
                idClaseExhorto: claseExhorto,
                idEstatus: estatus,
                idUsuarioElaboro: usuarioElaboro,
                idUsuarioAsignacion: usuarioAsignado
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, materia, autoridad, numeroReferencia, fecha, objetoExhorto, claseExhorto, estatus, usuarioElaboro, usuarioAsignado ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Exhortos librados' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography> }
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>
                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>
                                        <Select
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado || materia === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <TextField
                                        fullWidth
                                        label='Número de referencia'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        autoComplete='off'
                                        variant='outlined'
                                        value={ numeroReferencia }
                                        onChange={ (e) => setNumeroReferencia(e.target.value) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />
                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">
                                        <DatePicker
                                            label='Fecha del exhorto librado'
                                            sx={{ width: '100%' }}
                                            value={ fecha ? moment( fecha ) : null }
                                            maxDate={ moment( new Date() ) }
                                            onChange={ ( newValue ) => setFecha(newValue ? newValue.format('YYYY-MM-DD') : '' ) }
                                            disabled={ filtroAplicado }
                                            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Estatus</InputLabel>
                                        <Select
                                            label='Estatus'
                                            value={ estatus }
                                            onChange={ (e) => setEstatus( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                estatusArray
                                                .filter(({ idEstatus }) => [3, 43, 44, 45].includes( idEstatus ))
                                                .map(({ idEstatus, descripcion }) => (
                                                    <MenuItem key={ idEstatus } value={ idEstatus }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Objeto de Exhorto</InputLabel>
                                        <Select
                                            label="Objeto de Exhorto"
                                            value={ objetoExhorto }
                                            onChange={ (e) => setObjetoExhorto( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                objetoExhortoArray.map( ({ idObjetoExhorto, descripcion }) => (
                                                    <MenuItem key={ idObjetoExhorto } value={ idObjetoExhorto }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Clase del exhorto</InputLabel>
                                        <Select
                                            label="Clase del exhorto"
                                            value={ claseExhorto }
                                            onChange={ (e) => setClaseExhorto( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                claseExhortoArray.map( ({ idClaseExhorto, descripcion }) => (
                                                    <MenuItem key={ idClaseExhorto } value={ idClaseExhorto }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Usuario elaboró el exhorto librado</InputLabel>
                                        <Select
                                            label="Usuario elaboró el exhorto librado"
                                            value={ usuarioElaboro }
                                            onChange={ (e) => setUsuarioElaboro( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuarioElaboroArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Asignado a</InputLabel>
                                        <Select
                                            label="Asignado a"
                                            value={ usuarioAsignado }
                                            onChange={ (e) => setUsuarioAsignado( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuarioAsignadoArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' } alignContent={ 'center' }>
                                    <Button
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ loadingSearch }
                                        disabled={ !filtroAplicado && (materia === 0 && autoridad === 0 && numeroReferencia === '' && !fecha && objetoExhorto === 0 && claseExhorto === 0 && estatus === 0 && usuarioElaboro === 0 && usuarioAsignado === 0 ) }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                        sx={{ mt: 1, px: 5 }}
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar'}
                                    </Button>
                                </Grid>
                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'right' }>

                    <Button
                        color='secondary'
                        variant="outlined"
                        sx={{ mt: 1 }}
                        loading={ loadingDescargar }
                        disabled={ rows.length === 0 }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                  <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Exhorto Librado</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Objeto del exhorto</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Clase del exhorto</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Usuario elaboró el exhorto</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( row, index ) => {

                                        const { numeroSeguimiento, fecha, numeroExhorto, referencia, objetoExhorto, claseExhorto, usuarioAsignado, estatus, idEstatus, documento, usuarioElaboro } = row;

                                        return (
                                            <TableRow key={index} sx={{ '& td': { py: 2 } }}>

                                                <TableCell sx={{ textAlign: 'center' }}>

                                                    <Typography variant='h6'>
                                                        { numeroSeguimiento }
                                                    </Typography>

                                                    {
                                                        fecha
                                                        &&
                                                            <>

                                                                <Typography variant='subtitle1' fontSize={ 14 }>
                                                                    { moment( fecha ).format( 'DD-MM-YYYY' ) }
                                                                </Typography>

                                                                <Typography variant='caption' color='text.secondary'>
                                                                    { moment( fecha ).format( 'hh:mm a' ) }
                                                                </Typography>

                                                            </>
                                                    }

                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}>

                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>

                                                        {
                                                            documento
                                                            ?
                                                                <Button
                                                                    fullWidth
                                                                    variant='contained'
                                                                    onClick={ () => { setDocumento( documento ); setOpenDocumento( true ); } }
                                                                >
                                                                    { numeroExhorto }
                                                                </Button>
                                                            :
                                                                <Typography variant='subtitle1' fontWeight={ 'bold' }>
                                                                    { numeroExhorto }
                                                                </Typography>
                                                        }

                                                    </Box>

                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    {
                                                        referencia
                                                        &&
                                                            <Button
                                                                fullWidth
                                                                variant='contained'
                                                                sx={{ textTransform: 'none' }}
                                                                onClick={ () => handleVerDetalle( row ) }
                                                            >
                                                                { referencia }
                                                            </Button>
                                                    }
                                                </TableCell>

                                                <TableCell>
                                                    <Typography variant='subtitle1' fontSize={ 14 }>
                                                        { objetoExhorto }
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography variant='subtitle1' fontSize={ 14 }>
                                                        { claseExhorto }
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography variant='body2' fontSize={ 13 } sx={{ textTransform: 'uppercase' }}>
                                                        {usuarioElaboro}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell sx={{ textAlign: 'center' }} >

                                                    <Chip
                                                        variant='filled'
                                                        sx={{ fontWeight: 'bold', mb: 1 }}
                                                        color={ idEstatus === 3 ? 'primary' : 'default' }
                                                        label={ <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 13 }> { estatus } </Typography> }
                                                    />

                                                    {
                                                        usuarioAsignado
                                                        &&
                                                            <Box sx={{ mt: 0.5 }}>

                                                                <Typography variant='caption' sx={{ fontWeight: 'bold', display: 'block', color: 'text.secondary' }}>
                                                                    Asignado a:
                                                                </Typography>

                                                                <Typography variant='caption' sx={{ display: 'block', color: 'text.secondary', textTransform: 'uppercase', fontSize: 11 }}>
                                                                    {usuarioAsignado}
                                                                </Typography>

                                                            </Box>
                                                    }

                                                </TableCell>

                                            </TableRow>

                                            );
                                        })
                                    }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>
                                            <TableCell colSpan={ 7 } align="center">
                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                            </TableCell>
                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>
                                                <TableCell colSpan={ 7 } align="center">
                                                    <CircularProgress size={ 26 } />
                                                </TableCell>
                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={ [5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                        colSpan={ 5 }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => { setOpenDocumento(false); setDocumento(''); } }
            />

            <DialogExpediente
                expediente={ expedienteSeleccionado }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <DialogExhortoRecibido
                exhortoRecibido={ exhortoRecibidoSeleccionado }
                openDialog={ openDialogExhortoRecibido }
                handleCloseDialog={ () => setOpenDialogExhortoRecibido( false ) }
            />

        </Layout>
    )
}